import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api } from "../api.js";
import { useAuth } from "../auth.js";
import { Card, COLORS, Page } from "../ui.js";

interface CountResp<T = unknown> {
  items: T[];
}

export default function Dashboard() {
  const { me } = useAuth();
  const firstName = me?.formateur.displayName.split(" ")[0] ?? "";

  const courses = useQuery({
    queryKey: ["courses"],
    queryFn: () => api.get<CountResp>("/courses"),
  });
  const offers = useQuery({
    queryKey: ["offers"],
    queryFn: () => api.get<CountResp>("/offers"),
  });
  const salesPages = useQuery({
    queryKey: ["sales-pages"],
    queryFn: () => api.get<CountResp>("/sales-pages"),
  });
  const assets = useQuery({
    queryKey: ["assets"],
    queryFn: () => api.get<CountResp>("/assets"),
  });

  const stats = [
    {
      label: "Cours",
      value: courses.data?.items.length,
      to: "/courses",
      hint: "Vos formations",
    },
    {
      label: "Médias",
      value: assets.data?.items.length,
      to: "/library",
      hint: "Vidéos, audio, PDF, images",
    },
    {
      label: "Offres",
      value: offers.data?.items.length,
      to: "/offers",
      hint: "Tarifs liés à vos cours",
    },
    {
      label: "Pages de vente",
      value: salesPages.data?.items.length,
      to: "/sales-pages",
      hint: "Publication & checkout Stripe",
    },
  ];

  return (
    <Page title={`Bonjour, ${firstName}`}>
      <p style={{ color: COLORS.muted }}>
        Votre Espace : <strong>{me?.espace.name}</strong> ({me?.espace.slug})
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: 16,
          marginTop: 24,
          marginBottom: 32,
        }}
      >
        {stats.map((s) => (
          <Link
            key={s.label}
            to={s.to}
            style={{ textDecoration: "none", color: COLORS.text }}
          >
            <Card style={{ margin: 0, height: "100%" }}>
              <div style={{ color: COLORS.muted, fontSize: 13 }}>{s.label}</div>
              <div style={{ fontSize: 32, fontWeight: 700, marginTop: 4 }}>
                {s.value ?? "—"}
              </div>
              <div style={{ fontSize: 12, color: COLORS.muted, marginTop: 4 }}>{s.hint}</div>
            </Card>
          </Link>
        ))}
      </div>

      <Card>
        <h3 style={{ marginTop: 0 }}>Pour démarrer</h3>
        <ol style={{ color: COLORS.muted, lineHeight: 1.9 }}>
          <li>
            <Link to="/library">Uploadez vos médias</Link> (vidéo, audio, PDF, images)
          </li>
          <li>
            <Link to="/courses">Créez un Cours</Link>, ajoutez Modules et Leçons, éditez chaque
            leçon avec le builder par blocs
          </li>
          <li>
            <Link to="/offers">Créez une Offre</Link> liée à un ou plusieurs Cours, fixez le prix
          </li>
          <li>
            <Link to="/sales-pages">Créez une Page de vente</Link> depuis un template ou de zéro,
            publiez-la, partagez l'URL publique
          </li>
          <li>
            <Link to="/stripe">Connectez Stripe</Link> pour activer les paiements réels
          </li>
        </ol>
      </Card>
    </Page>
  );
}
